module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "md-mask"
  }, [_c('div', {
    staticClass: "md-container"
  }, [_c('div', {
    staticClass: "md-dialog-header"
  }, [_c('div', {
    staticClass: "md-header-content"
  }, [_c('div', {
    staticClass: "icon-pill"
  }, [_c('svg', {
    staticStyle: {
      "width": "16px",
      "height": "16px"
    },
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "11",
      "width": "18",
      "height": "11",
      "rx": "2",
      "ry": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M7 11V7a5 5 0 0 1 10 0v4"
    }
  })])]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('p', {
    staticClass: "md-subtitle"
  }, [_vm._v("Runner: " + _vm._s(_vm.runnerName) + " (ID: " + _vm._s(_vm.runnerId) + ")")])])]), _vm._v(" "), _c('button', {
    staticClass: "md-close-btn",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "md-dialog-body"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "gap": "8px"
    }
  }, [_c('label', {
    staticClass: "md-label",
    staticStyle: {
      "font-size": "12px",
      "margin": "0"
    },
    attrs: {
      "for": "new-password"
    }
  }, [_vm._v("New Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "md-input",
    attrs: {
      "type": "password",
      "id": "new-password",
      "placeholder": "Enter new password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.savePassword.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "md-error"
  }, [_vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "md-dialog-footer"
  }, [_c('button', {
    staticClass: "md-ghost-btn",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n        Cancel\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "md-primary-btn",
    attrs: {
      "disabled": _vm.loading || !_vm.password || _vm.password.length < 4
    },
    on: {
      "click": _vm.savePassword
    }
  }, [_vm._v("\n        " + _vm._s(_vm.loading ? 'Saving...' : 'Save Password') + "\n      ")])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c5209d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/PasswordManagementModal.vue
// module id = 1687
// module chunks = 2